import React from "react";
import { X } from "lucide-react";

import "./FormModal.css";

export default function FormModal({
  isOpen,
  onClose,
  children,
  closeDisabled = false,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="form-modal__overlay"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !closeDisabled) {
          onClose?.();
        }
      }}
    >
      <div
        className="form-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Form"
      >
        <button
          type="button"
          className="form-modal__close"
          onClick={onClose}
          disabled={closeDisabled}
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <div className="form-modal__body">{children}</div>
      </div>
    </div>
  );
}
